// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1-lmk","info":"UpdateTermsInfo_info__3AsFL"};